import { CfPageExtra } from "types/pages/types";
import { useGetPathTemplatePageExtra } from "./staticQueries/useGetPathTemplatePageExtra";

export function getExtraPagesReference<T extends { pageExtra: CfPageExtra[] }>(
  pages: T[],
) {
  let listPageExtra;

  if (pages && pages !== null) {
    listPageExtra = pages
      .filter((item) => {
        if (!Array.isArray(item.pageExtra)) {
          return false;
        }
        return true;
      })
      .map((item) => {
        const currentItemPage = item.pageExtra[0];
        let pathTemplateSlug = useGetPathTemplatePageExtra(currentItemPage);
        pathTemplateSlug =
          pathTemplateSlug !== "" ? `/${pathTemplateSlug}` : "";
        const currentItemPageUrl = `/${currentItemPage.node_locale}${pathTemplateSlug}/${currentItemPage.slug}`;
        const currentItem = { ...item, currentItemPageUrl };
        return currentItem;
      });
  }
  return listPageExtra;
}
